// extracted by mini-css-extract-plugin
var _1 = "tooltip--BPiFs";
var _2 = "tooltip-content--M_CkR";
var _3 = "tooltip-pointer-bottom--GuyWT";
var _4 = "tooltip-pointer-left--gedhh";
var _5 = "tooltip-pointer-right--J7lFL";
var _6 = "tooltip-pointer-top--MYmz0";
export { _1 as "tooltip", _2 as "tooltip-content", _3 as "tooltip-pointer-bottom", _4 as "tooltip-pointer-left", _5 as "tooltip-pointer-right", _6 as "tooltip-pointer-top" }
